import { render, staticRenderFns } from "./algorithmResultQuery.vue?vue&type=template&id=c10d4fc2&scoped=true"
import script from "./algorithmResultQuery.vue?vue&type=script&lang=js"
export * from "./algorithmResultQuery.vue?vue&type=script&lang=js"
import style0 from "./algorithmResultQuery.vue?vue&type=style&index=0&id=c10d4fc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c10d4fc2",
  null
  
)

export default component.exports